"use client";

import { useState } from "react";
import {
  Link,
  useNavigate,
  useLocation,
} from "react-router-dom";
import {
  HomeIcon,
  BriefcaseIcon,
  UsersIcon,
  BuildingOfficeIcon,
  MapPinIcon,
  CreditCardIcon,
  EnvelopeIcon,
  Bars3Icon,
  XMarkIcon,
  ChevronDownIcon,
  ChevronUpIcon,
} from "@heroicons/react/24/outline"; 
import "./AdminDash.css";
import logos from "./indiahiringslogo.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSignOutAlt } from "@fortawesome/free-solid-svg-icons";
import { useDispatch } from "react-redux";
import { logoutAsync } from "../../../auth/authSlices";
import Cookies from "js-cookie";

const AdminLgBar = () => {
  const [selectedLink, setSelectedLink] = useState("admin-dashboard");
  const [openDropdown, setOpenDropdown] = useState("");
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  // useEffect(() => {
  //   const path = location.pathname.split("/");
  //   const currentPath = path[2] || "admin-dashboard";
  //   setSelectedLink(currentPath);
  // }, [location]);

  const handleClick = (link, path) => {
    setSelectedLink(link);
    navigate(path);
    if (window.innerWidth < 1024) {
      setIsSidebarOpen(false);
    }
  };

  const toggleDropdown = (dropdown) => {
    setOpenDropdown((prev) => (prev === dropdown ? "" : dropdown));
  };

  const navItems = [
    {
      name: "admin-dashboard",
      icon: HomeIcon,
      path: "/admin-dashboard",
      label: "Dashboard",
    },
    {
      name: "jobPosting",
      icon: BriefcaseIcon,
      label: "Job Posting",
      subItems: [
        { name: "jobTitles", path: "/admin-dashboard/jobTitles", label: "Job Types" },
        {
          name: "jobDepartments",
          path: "/admin-dashboard/jobDepartments",
          label: "Departments",
        },
        {
          name: "jobEducationCourse",
          path: "/admin-dashboard/jobEducationCourse",
          label: "Education",
        },
        {
          name: "jobEducationCourseSpecialty",
          path: "/admin-dashboard/jobEducationCourseSpecialty",
          label: "Education Speciality",
        },
        {
          name: "jobMinmQualif",
          path: "/admin-dashboard/jobMinmQualif",
          label: "Education Qualifications",
        },
        {
          name: "core-industry",
          path: "/admin-dashboard/core-industry",
          label: "Industries",
        },
        // { name: "jobPostLocations", path: "/admin-dashboard/jobPostLocations", label: "Locations" },
        { name: "reqdSkills", path: "/admin-dashboard/reqdSkills", label: "Skills" },
      ],
    },
    {
      name: "candidateProfile",
      icon: UsersIcon,
      path: "/admin-dashboard/candidateProfile",
      label: "Candidates",
    },
    {
      name: "employersProfile",
      icon: BuildingOfficeIcon,
      path: "/admin-dashboard/employersProfile",
      label: "Employers",
    },
    {
      name: "cityList",
      icon: MapPinIcon,
      path: "/admin-dashboard/cityList",
      label: "Cities",
    },
    {
      name: "companyList",
      icon: BuildingOfficeIcon,
      path: "/admin-dashboard/companyList",
      label: "Companies",
    },
    {
      name: "adminJobs",
      icon: BuildingOfficeIcon,
      path: "/admin-dashboard/adminJobs",
      label: "Admin Jobs",
    },
    {
      name: "subscriptions",
      icon: CreditCardIcon,
      label: "Subscriptions",
      subItems: [
        {
          name: "createplan",
          path: "/admin-dashboard/createplan",
          label: "Create Plan",
        },
        {
          name: "subscriber-list",
          path: "/admin-dashboard/subscriber-list",
          label: "Subscriber List",
        },
      ],
    },
    {
      name: "testimonials",
      icon: EnvelopeIcon,
      path: "/admin-dashboard/testimonials",
      label: "Testimonials",
    },
    {
      name: "reviews",
      icon: EnvelopeIcon,
      path: "/admin-dashboard/reviews",
      label: "Admin Reviews",
    },
  ];

  const dispatch = useDispatch();

  const handleLogout = async () => {
    Cookies.remove("userToken");
    await dispatch(logoutAsync());
    navigate("/");
    window.location.reload();
    // setIsDrawerOpen(false);
  };

  // console.log("location", location.pathname);

  return (
    <>
      {/* Mobile Toggle Button */}
      <button
        onClick={() => setIsSidebarOpen(!isSidebarOpen)}
        className="fixed top-4 right-4 z-50 lg:hidden bg-blue-600 text-white p-2 rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
      >
        {isSidebarOpen ? (
          <XMarkIcon className="h-6 w-6" />
        ) : (
          <Bars3Icon className="h-6 w-6" />
        )}
      </button>

      {/* Sidebar Backdrop */}
      {isSidebarOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-40 lg:hidden"
          onClick={() => setIsSidebarOpen(false)}
        />
      )}

      {/* <div> */}
      {/* <RoleBasedProtectedRoute
        onRoleCheck={(role) => {
          console.log(`User role: ${role}`);
        }}
      >
        {({ role }) =>
          !location.pathname.startsWith("/admin-dashboard") && role === "admin" ? (
            <Navigate to="/admin-dashboard" replace />
          ) : (
            <div className="">
              <Outlet />
            </div>
          )
        }
      </RoleBasedProtectedRoute> */}
      {/* </div> */}

      {/* Sidebar */}
      <aside
        className={`
    fixed top-0 left-0 z-40 h-full w-64 bg-[#1a1f37] transform transition-transform duration-300 ease-in-out
    flex flex-col
    ${isSidebarOpen ? "translate-x-0" : "-translate-x-full"}
    lg:translate-x-0
  `}
      >
        {/* Logo */}
        <div className="flex items-center justify-start h-16 px-6 border-b border-gray-700">
          <img
            src={
              logos ||
              "https://hebbkx1anhila5yf.public.blob.vercel-storage.com/image-rrPTC08ef56nEo1w6JgsnrQ7vJ3LsP.png"
            }
            alt="Logo"
            className="h-12 w-auto"
          />
        </div>

        {/* Navigation - Scrollable */}
        <nav className="px-4 py-4 space-y-1 overflow-y-auto flex-1 sidebar-scroll-container">
          {navItems.map((item) => (
            <div key={item.name} className="py-1">
              {item.subItems ? (
                <div>
                  <button
                    onClick={() => toggleDropdown(item.name)}
                    className={`
                w-full flex items-center justify-between px-3 py-2 text-sm rounded-lg
                ${
                  openDropdown === item.name
                    ? "bg-[#4b49ac] text-white"
                    : "text-gray-300 hover:bg-gray-700"
                }
                transition-colors duration-150 ease-in-out
              `}
                  >
                    <div className="flex items-center">
                      <item.icon className="h-5 w-5 mr-3" />
                      <span>{item.label}</span>
                    </div>
                    {openDropdown === item.name ? (
                      <ChevronUpIcon className="h-4 w-4" />
                    ) : (
                      <ChevronDownIcon className="h-4 w-4" />
                    )}
                  </button>
                  {openDropdown === item.name && (
                    <div className="mt-2 ml-4 space-y-1">
                      {item.subItems.map((subItem) => (
                        <Link
                          key={subItem.name}
                          to={subItem.path}
                          onClick={() =>
                            handleClick(subItem.name, subItem.path)
                          }
                          className={`
                      block px-3 py-2 text-sm rounded-lg
                      ${
                        selectedLink === subItem.name
                          ? "bg-[#4b49ac] text-white"
                          : "text-gray-300 hover:bg-gray-700"
                      }
                      transition-colors duration-150 ease-in-out
                    `}
                        >
                          {subItem.label}
                        </Link>
                      ))}
                    </div>
                  )}
                </div>
              ) : (
                <Link
                  to={item.path}
                  onClick={() => handleClick(item.name, item.path)}
                  className={`
              flex items-center px-3 py-2 text-sm rounded-lg
              ${
                selectedLink === item.name
                  ? "bg-[#4b49ac] text-white"
                  : "text-gray-300 hover:bg-gray-700"
              }
              transition-colors duration-150 ease-in-out
            `}
                >
                  <item.icon className="h-5 w-5 mr-3" />
                  <span>{item.label}</span>
                </Link>
              )}
            </div>
          ))}
        </nav>

        {/* Logout Button - Stuck to Bottom */}
        <div className="p-4 mt-auto">
          <button
            onClick={handleLogout}
            className="w-full py-2 bg-red-600 text-white font-medium rounded-md hover:bg-red-700 transition-colors duration-200 flex items-center justify-center"
          >
            <FontAwesomeIcon icon={faSignOutAlt} className="mr-2" />
            Logout
          </button>
        </div>
      </aside>

      {/* Main Content */}
      <main
        className={`
        transition-all duration-300 ease-in-out
        lg:ml-64
      `}
      >
        <div className=""></div>
      </main>
    </>
  );
};

export default AdminLgBar;
